import { faqs } from "@/mocks/gossipData";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  return (
    <section id="faq" className="wrap py-14 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="mx-auto max-w-3xl text-center">
        <p className="mb-2 text-xs font-bold uppercase tracking-widest text-primary-600">FAQ</p>
        <h2 className="font-display text-2xl font-black text-foreground-950 md:text-4xl">你关心的，这里都有答案</h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
          关于更新节奏、内容来源与投稿方式，我们一次说清楚。还有别的疑问？欢迎在下方联系我们。
        </p>
      </div>

      <div className="mx-auto mt-10 max-w-3xl space-y-3">
        {faqs.map((f) => (
          <details
            key={f.q}
            open
            className="group rounded-lg border border-background-200 bg-background-50 p-5 open:border-primary-200"
          >
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-display text-base font-bold text-foreground-950 marker:content-none md:text-lg">
              <span className="inline-flex items-start gap-2">
                <i className="ri-question-line mt-1 text-primary-500"></i>
                {f.q}
              </span>
              <i className="ri-arrow-down-s-line text-xl text-foreground-400 transition group-open:rotate-180"></i>
            </summary>
            <p className="mt-3 border-t border-background-200 pt-3 text-sm leading-relaxed text-foreground-700">{f.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}